import ChevronIcon from 'components/icons/ChevronIcon';
import React from 'react';

const CSS = require('./TopButtons.module.scss');

function TopButtons({
  prevButtonDisabled,
  nextButtonDisabled,
  onPrevious,
  onNext,
}) {
  return (
    <div className={CSS.ButtonContainer}>
      <button
        className={CSS.Button}
        disabled={prevButtonDisabled}
        onClick={onPrevious}
      >
        <ChevronIcon
          direction="left"
          width={8}
          height={14}
          className={CSS.ChevronIcon}
        />
      </button>
      <button
        className={CSS.Button}
        disabled={nextButtonDisabled}
        onClick={onNext}
      >
        <ChevronIcon
          direction="right"
          width={8}
          height={14}
          className={CSS.ChevronIcon}
        />
      </button>
    </div>
  );
}

export default TopButtons;
